module.exports = __webpack_public_path__ + "img/shopping-cart-02.a52738c8.svg";